import React from 'react';
import PropTypes from 'prop-types';

import { useFetchStatus } from '../../../../../../utils/fetchStatusUtils';
import Card from '../../../../../../components/Card';
import CardsSkeleton from '../../../../../../components/Skeletons/CardsSkeleton';

const Cards = (props) => {
  const { cashbacksData, loadingState } = props;

  const numberOfStatistics = 3;

  const { isFulfilled } = useFetchStatus(loadingState);

  if (!isFulfilled) {
    return <CardsSkeleton count={numberOfStatistics} />;
  }

  const {
    cashbacksCount,
    netCashbacksAmount,
    spentCashbacksAmount,
    refundCashbacksAmount,
    earnedCashbacksAmount,
  } = cashbacksData;

  const tooltipContent = `Earned FastCash: $${earnedCashbacksAmount}
  Refund FastCash: $${refundCashbacksAmount}`;

  return (
    <div className="card-container">
      <Card title="FastCash Total" content={cashbacksCount} />
      <Card
        title="Net Earned FastCash"
        content={`$${netCashbacksAmount}`}
        tooltipContent={tooltipContent}
      />
      <Card title="Spent FastCash" content={`$${spentCashbacksAmount}`} />
    </div>
  );
};

export default Cards;

Cards.propTypes = {
  cashbacksData: PropTypes.shape({
    cashbacksCount: PropTypes.number.isRequired,
    netCashbacksAmount: PropTypes.number.isRequired,
    spentCashbacksAmount: PropTypes.number.isRequired,
  }),
  loadingState: PropTypes.string.isRequired,
};

Cards.defaultProps = {
  cashbacksData: null,
};
